export function mountParams(value) {
  let params = '';
  const keys = Object.keys(value);
  keys.forEach((item, index) => {
    if (index === 0) params += `?${item}=${value[item]}`;
    else params += `&${item}=${value[item]}`;
  });
  return params;
}
